module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/assessment_achievements/4_fe6cabd77f01c63e40aa7fc29bc52446.png";